import React from 'react';
import {Col, Form, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";

const TopicSettingBox = ({
                           propTopicInfo,
                           propSetTopicInfo,
                           propType,
                           propOnReset,
                           propOnSubmit
                         }) => {

  const onChangeTopic = (e) => {
    propSetTopicInfo((prev) => {
      return {...prev, topic: e.target.value};
    });
  };

  const onChangeReadPermission = (e) => {
    if (e.target.value === "on") {
      propSetTopicInfo((prev) => {
        return {...prev, readPermission: 1};
      });
    } else {
      propSetTopicInfo((prev) => {
        return {...prev, readPermission: 0};
      });
    }
  };

  const onChangeWritePermission = (e) => {
    if (e.target.value === "on") {
      propSetTopicInfo((prev) => {
        return {...prev, writePermission: 1};
      });
    } else {
      propSetTopicInfo((prev) => {
        return {...prev, writePermission: 0};
      });
    }
  };

  const onChangeRm = (e) => {
    propSetTopicInfo((prev) => {
      return {...prev, rm: e.target.value};
    });
  };

  return (
      <Form
          id={"settingForm"}
          className={"setting-form search-form"}
          onSubmit={propOnSubmit}
      >
        <Row className={""}>
          <Col md={12}>
            <Row>
              <Col md={6}>
                <Form.Group as={Row} controlId="formBasicSelectMenu">
                  <Form.Label column sm={2} className={"label text-end"}>
                    Topic
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                        type="text"
                        placeholder=""
                        className={"input-search text-white"}
                        value={propTopicInfo.topic || ''}
                        onChange={onChangeTopic}
                        disabled={propType === "put"}
                    />
                  </Col>
                </Form.Group>
              </Col>

              <Col md={2}>
                <Row className={"justify-content-between"}>
                  <Col md={6}>
                    <Row className={"justify-content-end"}>
                      <Form.Label column md={6} className={"label text-end "}>
                        Read
                      </Form.Label>
                      <Col md={6} className={"checkbox-div"}>
                        <input type="checkbox"
                               className={"checkbox check"}
                               onChange={onChangeReadPermission}
                               defaultChecked={propTopicInfo.readPermission}
                               key={propTopicInfo.readPermission}
                        />
                      </Col>
                    </Row>
                  </Col>

                  <Col md={6}>
                    <Row className={"justify-content-center"}>
                      <Form.Label column md={6} className={"label text-end "}>
                        Write
                      </Form.Label>
                      <Col md={6} className={"checkbox-div"}>
                        <input type="checkbox"
                               className={"checkbox check"}
                               onChange={onChangeWritePermission}
                               defaultChecked={propTopicInfo.writePermission}
                               key={propTopicInfo.writePermission}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>

              <Col md={4}>
                <Form.Group as={Row} controlId="formBasicSelectMenu">
                  <Form.Label column sm={4} className={"label text-end"}>
                    비고
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                        type="text"
                        placeholder=""
                        className={"input-search text-white"}
                        value={propTopicInfo.rm}
                        onChange={onChangeRm}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>

        <hr/>

        <Row className={"flex-row-reverse mt-2"}>
          <Col md={2} className={"text-center"}>
            {propType === "post" ? (
                <Button type={"submit"} onClick={propOnSubmit} className={"save-btn px-5"}>
                  저장
                </Button>
            ) : (
                <Button type={"submit"} onClick={propOnSubmit} className={"save-btn px-5"}>
                  수정
                </Button>
            )}
          </Col>

          <Col md={2} className={"text-end"}>
            <Button type={"reset"} onClick={propOnReset} className={"btn-secondary px-5"}>
              초기화
            </Button>
          </Col>
        </Row>
      </Form>
  );
};

export default TopicSettingBox;
